import { useContext } from 'react';
import { AuthContext } from '../../data/context/AuthContext';

/**
 * UseAuth
 * @constructor
 */
export function UseAuth() {
  return useContext(AuthContext);
}
